import {LOCAL_STORAGE_PICK_KEY} from "data/constants";
import {Bindings} from "data/constants/bindings";
import {IPickResponse} from "data/providers/api/pinpoint.api.provider";
import type {IPlayersStore} from "data/stores/players/players.store";
import type {IRoundsStore} from "data/stores/rounds/rounds.store";
import {ViewController} from "data/types/structure";
import {inject, injectable} from "inversify";
import {makeAutoObservable, observable} from "mobx";
import type {useNavigate} from "react-router-dom";

interface ILandingControllerProps {
	navigate: ReturnType<typeof useNavigate>;
}

export interface ILandingController extends ViewController<ILandingControllerProps> {
	get isLoading(): boolean;
}

@injectable()
export class LandingController implements ILandingController {
	@observable private _isLoading: boolean = false;

	constructor(
		@inject(Bindings.RoundsStore) private _roundStore: IRoundsStore,
		@inject(Bindings.PlayersStore) private _playerStore: IPlayersStore
	) {
		makeAutoObservable(this);
	}

	get isLoading() {
		return this._isLoading;
	}

	async init({navigate}: ILandingControllerProps) {
		this._isLoading = true;

		await Promise.all([this._roundStore.fetchRounds(), this._playerStore.fetchPlayers()]);

		const getPick = JSON.parse(
			localStorage.getItem(LOCAL_STORAGE_PICK_KEY) || "null"
		) as IPickResponse | null;

		if (getPick && getPick.roundId) {
			const round = this._roundStore.getRoundById(getPick.roundId);

			if (round && round.id) {
				navigate(`/pick/${round.id}`);
			} else {
				localStorage.removeItem(LOCAL_STORAGE_PICK_KEY);
			}
		}

		this._isLoading = false;
	}
}
